import { skipToken, useQuery } from '@tanstack/react-query'
import type { SettingsApiGetECommerceTextCopiesRequest } from '@itsrever/rever-api'
import { useAppDispatch } from '@/redux/hooks'
import { setCustomCopies, settingsApi } from '@/redux/api/settingsApiSlice'

export const useCustomCopies = ({
    slug
}: SettingsApiGetECommerceTextCopiesRequest) => {
    const dispatch = useAppDispatch()

    return useQuery({
        queryKey: ['copies', slug],
        queryFn: slug
            ? async () => {
                  const { data } = await settingsApi.getECommerceTextCopiesV3({
                      slug
                  })

                  dispatch(setCustomCopies(data))

                  return data
              }
            : skipToken,
        staleTime: 24 * 60 * 60 * 1000 // 1 day
    })
}
